import { render, staticRenderFns } from "./AdminStatisticsComponent.vue?vue&type=template&id=2f96a539&"
import script from "./AdminStatisticsComponent.vue?vue&type=script&lang=ts&"
export * from "./AdminStatisticsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports